module.exports = __webpack_public_path__ + "img/interface-min.baa16fde.png";